import React, { useEffect } from "react";

export const useDidMount = (effect: React.EffectCallback) => {
  useEffect(effect, []);
};
